import { LEADERSHIP_ATTENTION_DASHBOARD_API_URL } from "../config/constants";
import { apiFetch } from "../utils/apiClient";


const getAuthHeader = () => {
  const token =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("accessToken");

  if (!token) return {};

  const tokenType = sessionStorage.getItem("tokenType") || "Bearer";
  const normalizedToken = token
    .replace(/^"|"$/g, "")
    .replace(/^Bearer\s+/i, "")
    .trim();

  if (!normalizedToken) return {};
  return { Authorization: `${tokenType} ${normalizedToken}` };
};

const buildQueryString = (params)=> {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, String(value));
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

export async function fetchLeadershipAttentionProjects(
  params,
) {
  const response = await apiFetch(
    `${LEADERSHIP_ATTENTION_DASHBOARD_API_URL}${buildQueryString(params)}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        ...getAuthHeader(),
      },
    },
    "Failed to load leadership attention projects.",
  );

  if (!response.ok) {
    throw new Error(`Failed to load leadership attention projects (${response.status}).`);
  }

  return (await response.json())
}
